module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-02-m-jp.4c6d10e5474c811098e95ef48734fc4d.png";